// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__6TFU5","columnSkeleton":"styles_columnSkeleton__3tMBK"};